export default "__VITE_ASSET__f73cefcc__"